import { FC } from 'react';

import { Box, CogOutline, Popover, PopoverContent, PopoverTrigger, Select } from '@bonusly/design-system';

interface Device {
	deviceId: string;
	label: string;
}

interface DeviceSettingsProps {
	selectedVideoDeviceId: string;
	selectedAudioDeviceId: string;
	devices: {
		video: Device[];
		audio: Device[];
	};
	onDeviceChange: (deviceId: string, type: 'video' | 'audio') => void;
}

export const DeviceSettings: FC<DeviceSettingsProps> = ({ selectedVideoDeviceId, selectedAudioDeviceId, devices, onDeviceChange }) => (
	<Box display="flex" flexDirection="row">
		<Popover placement="bottom-end" closeOnEsc={true} closeOnBlur={true}>
			{({ onClose }) => (
				<>
					<PopoverTrigger>
						<Box bg="rgba(0, 0, 0, 0.3)" rounded="md" p={2} display="flex" alignItems="center">
							<CogOutline opacity="100%" size="sm" color="white" />
						</Box>
					</PopoverTrigger>
					<PopoverContent width="fit-content" p={2}>
						<Select
							variant="unstyled"
							p={4}
							value={selectedVideoDeviceId}
							onChange={(e) => {
								onClose();
								onDeviceChange(e.target.value, 'video');
							}}
						>
							{devices.video.map((device) => (
								<option key={device.deviceId} value={device.deviceId}>
									{device.label}
								</option>
							))}
						</Select>
						<Select
							variant="unstyled"
							p={4}
							value={selectedAudioDeviceId}
							onChange={(e) => {
								onClose();
								onDeviceChange(e.target.value, 'audio');
							}}
						>
							{devices.audio.map((device) => (
								<option key={device.deviceId} value={device.deviceId}>
									{device.label}
								</option>
							))}
						</Select>
					</PopoverContent>
				</>
			)}
		</Popover>
	</Box>
);
